<template>
    <!--Promotion dialigs-->
    <div id="dialog-width"  class="text-xs-center">

        <v-dialog content-class="promotion-dialog" v-model="showDialog" scrollable @input="handler">

            <v-card>

                <v-img
                    :src="promotionDetail.url"
                    :alt="promotionDetail.name"
                    contain
                ></v-img>

                <i class="far fa-times-circle close-icon" @click.prevent="update(true)"></i>

                <v-card-text v-html="promotionDetail.description" style="height: 80%;"></v-card-text>

            </v-card>

        </v-dialog>

    </div>

</template>

<script>
export default {
     name: "Dialog-Promotions",
    props: ["dialog", "promotion"],
    data() {
        return {
            showDialog: this.dialog,
            downInner: false,
            skip: false,
        }
    },
    computed: {
        promotionDetail: function(){
            return this.promotion
        }
    },
    watch: {
        dialog(newValue) {

            return this.showDialog = newValue;

        },
        showDialog(newValue) {

            if ( this.skip ) {

                this.downInner = true;

                return this.skip = false;

            }

            return this.downInner = false;

        }
    },
    methods: {
        handler() {
            if (this.downInner === false) {

                this.update();

            }
        },
        async update(skipValue = false) {

            this.skip = skipValue;

            this.showDialog = !this.showDialog;

            this.$emit("DialogChanged", this.showDialog);

        }

    }

}
</script>

<style scoped>

    .close-icon {
        position: absolute;
        right: 0px;
        font-size: 25px;
        color: rgb(246 246 246);
        cursor: pointer;
        background-color: #000000;
        border-radius: 12px;
        margin: 10px;
    }

    .close-icon:hover {
        color:#000000;
        background-color:rgb(246 246 246);
    }

</style>

<style>
    /*
    ##Device = Desktops
    ##Screen = 1281px to higher resolution desktops
    */

    @media (min-width: 1281px) {
        .promotion-dialog {
            width: 50% !important;
        }
    }

    /*
    ##Device = Laptops, Desktops
    ##Screen = B/w 1025px to 1280px
    */

    @media (min-width: 1025px) and (max-width: 1280px) {
        .promotion-dialog {
            width: 50% !important;
        }
    }

    /*
    ##Device = Tablets, Ipads (portrait)
    ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) {
        .promotion-dialog {
            width: 90% !important;
        }
    }

    /*
    ##Device = Tablets, Ipads (landscape)
    ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        .promotion-dialog {
            width: 90%;
        }
    }

    /*
    ##Device = Low Resolution Tablets, Mobiles (Landscape)
    ##Screen = B/w 481px to 767px
    */

    @media (min-width: 481px) and (max-width: 767px) {
        .promotion-dialog {
            width: 100%;
        }
    }

    /*
    ##Device = Most of the Smartphones Mobiles (Portrait)
    ##Screen = B/w 320px to 479px
    */

    @media (min-width: 320px) and (max-width: 480px) {
        .promotion-dialog {
            width: 100%;
        }
    }

    @media (max-width: 319px) {
        .promotion-dialog {
            width: 100%;
        }
    }
</style>
